import { OrderProduct } from "./orderproduct.model";

export class Sale {
$key:string;
orderid:string;
products:OrderProduct[];
date:string;
totalprice:number;
//discount?:number
 
}




// WEBPACK FOOTER //
// E:/Project/posSystem/src/app/pos/modals/order.model.ts